import React, { Fragment, useRef, useState } from 'react';
import { Menu as HMenu } from '@headlessui/react';
import { DotsHorizontalIcon } from '@heroicons/react/outline';
import Button from './Button';
import FloatingPanel from './FloatingPanel';
import Menu from './Menu';
import { cn } from './cn';

/** A row's context menu stays in the containing dialog and inside the viewport. */
function Body({ children, label, actions, open, variant }) {
  const inset = variant === 'inset';
  const trigger = useRef(null);
  const root = useRef(null);
  const anchor = useRef(null);
  const [portalTarget, setPortalTarget] = useState(null);
  const openAt = (event, context = false) => {
    setPortalTarget(root.current?.closest('[role="dialog"]') || document.body);
    const rect = event.currentTarget.getBoundingClientRect();
    const point = context && (event.clientX || event.clientY) ? { left: event.clientX, right: event.clientX, top: event.clientY, bottom: event.clientY, width: 0, height: 0 } : rect;
    anchor.current = { getBoundingClientRect: () => point };
  };
  return <div ref={root} className={cn('bun-hover-actions flex min-w-0 items-center', inset ? 'group relative [&>button:first-child]:pr-14 sm:[&>button:first-child]:pr-10' : 'gap-1')} onContextMenu={event => {
    event.preventDefault(); event.stopPropagation();
    openAt(event, true);
    if (!open) trigger.current?.click();
  }}>
    {children}
    <HMenu.Button as={Fragment}><Button ref={trigger} variant="ghost" size="sm" iconOnly revealOnHover className={inset ? 'absolute right-1 top-1/2 -translate-y-1/2' : undefined} aria-label={label} onClick={event => { if (!anchor.current || event.detail > 0) openAt(event); }}><DotsHorizontalIcon className="h-4 w-4" /></Button></HMenu.Button>
    {open && <HMenu.Items as={FloatingPanel} static open anchorRef={anchor} portalTarget={portalTarget} width={220} autoFocus className="p-[6px] focus:outline-none" aria-label={label}>{actions}</HMenu.Items>}
  </div>;
}
export default function ContextMenu(props) {
  return <HMenu as="div">{({ open }) => <Body {...props} open={open} />}</HMenu>;
}
ContextMenu.Item = Menu.Item;
ContextMenu.Divider = Menu.Divider;
